import type { IconData } from '@stacksjs/iconify-core'

export const fo4x3: IconData = {
  "body": "<defs><clipPath id=\"SVGm7pw2cCQ\"><path fill-opacity=\".7\" d=\"M-78 32h640v480H-78z\"/></clipPath></defs><g fill-rule=\"evenodd\" stroke-width=\"0\" clip-path=\"url(#SVGm7pw2cCQ)\" transform=\"translate(78 -32)\"><path fill=\"#fff\" d=\"M-78 32h663.9v480H-78z\"/><path fill=\"#003897\" d=\"M-76 218.7h185.9V32H216v186.7h371.8v106.6H216V512H109.9V325.3h-186z\"/><path fill=\"#d72828\" d=\"M-76 245.3h212.4V32h53.1v213.3H588v53.4H189.5V512h-53V298.7H-76z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default fo4x3
